// extracted by mini-css-extract-plugin
export default {"Wrapper":"RecordNotFound_Wrapper__NoRpE"};